import { API } from '@/api';
import { DEFAULT_PARAMS } from './constants';

export const classes = {
  overlay: 'flex w-[96vw] max-w-[1200px]',
};

export async function fetchPracticeOrderData(orderId: number) {
  const [order, notes, keypoints] = await Promise.all([
    API.Orders.fetchOrder(orderId),
    fetchOrderNotes(orderId),
    fetchOrderKeypoints(orderId),
  ]);
  return {
    order,
    notes,
    keypoints,
  };
}

async function fetchOrderNotes(orderId: number) {
  return (await API.Orders.fetchOrderNotes(orderId, DEFAULT_PARAMS)).results;
}

async function fetchOrderKeypoints(orderId: number) {
  return (await API.Orders.fetchOrderKeypoints(orderId, DEFAULT_PARAMS))
    .results;
}
